import ProtectedRoute from "routes/ProtectedRoute";
import AdminLayout from "../../../components/UI/AdminLayout";

export const dashboardRoutes = [
  {
    path: "",
    element: (
      <ProtectedRoute>
        <AdminLayout />
      </ProtectedRoute>
    ), // Parent route
    children: [
      {
        path: "overview",
        lazy: async () => {
          const mod = await import("../../../views/Admin/Dashboard/overview");
          const OverView = mod.OverView;
          return {
            Component: () => <OverView />,
          };
        },
      },
    ],
  },
];
